
import { PackageProps } from "../../store/actionType";
import HandleUpdatePackage from "./components/HandleUpdatePackage";
type CreateUserProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  packageData: PackageProps;
};
const UpdatePackage: React.FC<CreateUserProps> = ({ closeModal, packageData }) => {
  return (
    <>
      <HandleUpdatePackage packageData={packageData} closeModal={closeModal} />
    </>
  );
};
export default UpdatePackage;
